import React from 'react';
import { NavLink  } from "react-router-dom";
import './DescriptionSection.scss';

const DescriptionSection = (props) => (
    <section className="section-description-link">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div className="first description">
              {props.children}
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="last button-wrapper">
              {
                !props.externalLink ?
                (
                  props.imageLink ?
                  <NavLink to={props.imageLink}>
                    <img className="image-button" src={props.imageButton} alt="" />
                  </NavLink> :
                  <img className="image-button" src={props.imageButton} alt="" />
                ) :
                <a href={props.externalLink}>
                  <img className="image-button" src={props.imageButton} alt="" />
                </a>
              }
            </div>
          </div>
        </div>
      </div>
    </section>
);

export default DescriptionSection;